// extracted by mini-css-extract-plugin
export default {"return_to_home":"ReturnToHome_return_to_home__QjALJ","on":"ReturnToHome_on__thjoe","light":"ReturnToHome_light__DVLtb"};